// Mock data para Casa das Ferramentas

export const brands = [
  { 
    id: 1, 
    name: 'STIHL', 
    logo: 'https://cdn.worldvectorlogo.com/logos/stihl.svg',
    featured: true,
    description: 'Líder mundial em motosserras e equipamentos de jardinagem profissional'
  },
  { 
    id: 2, 
    name: 'Makita', 
    logo: 'https://placehold.co/200x80/002B7F/FFFFFF?text=MAKITA',
    featured: true,
    description: 'Ferramentas elétricas profissionais de alta performance'
  },
  { 
    id: 3, 
    name: 'ESAB', 
    logo: 'https://cdn.worldvectorlogo.com/logos/esab.svg',
    featured: false
  },
  { 
    id: 4, 
    name: 'Bracol', 
    logo: 'https://placehold.co/200x80/FF6600/FFFFFF?text=BRACOL',
    featured: false
  },
  { 
    id: 5, 
    name: '3M', 
    logo: 'https://cdn.worldvectorlogo.com/logos/3m-5.svg',
    featured: false
  },
  { 
    id: 6, 
    name: 'Stanley', 
    logo: 'https://cdn.worldvectorlogo.com/logos/stanley-2.svg',
    featured: false
  },
  { 
    id: 7, 
    name: 'Marcon', 
    logo: 'https://placehold.co/200x80/005BAC/FFFFFF?text=MARCON',
    featured: false
  },
  { 
    id: 8, 
    name: 'Tramontina', 
    logo: 'https://cdn.worldvectorlogo.com/logos/tramontina.svg',
    featured: false
  }
];

export const categories = [
  { id: 'eletricas', name: 'Ferramentas Elétricas', icon: 'Drill' },
  { id: 'manuais', name: 'Ferramentas Manuais', icon: 'Wrench' },
  { id: 'jardinagem', name: 'Jardinagem', icon: 'Leaf' },
  { id: 'epis', name: 'EPIs', icon: 'Shield' },
  { id: 'acessorios', name: 'Acessórios', icon: 'Package' },
  { id: 'construcao', name: 'Construção', icon: 'HardHat' }
];

export const products = [
  // Ferramentas Elétricas - MAKITA
  {
    id: 1,
    name: 'Furadeira de Impacto 1/2" 760W',
    brand: 'Makita',
    category: 'eletricas',
    image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?w=500&h=400&fit=crop',
    description: 'Furadeira de impacto profissional com 760W de potência'
  },
  {
    id: 2,
    name: 'Esmerilhadeira Angular 4.1/2" 840W',
    brand: 'Makita',
    category: 'eletricas',
    image: 'https://images.unsplash.com/photo-1572981779307-38b8cabb2407?w=500&h=400&fit=crop',
    description: 'Esmerilhadeira angular para corte e desbaste'
  },
  {
    id: 3,
    name: 'Parafusadeira à Bateria 12V',
    brand: 'Makita',
    category: 'eletricas',
    image: 'https://images.unsplash.com/photo-1580402427914-a6cc60d7b44f?w=500&h=400&fit=crop',
    description: 'Parafusadeira compacta com bateria de lítio 12V'
  },
  {
    id: 4,
    name: 'Serra Tico-Tico 450W',
    brand: 'Makita',
    category: 'eletricas',
    image: 'https://images.unsplash.com/photo-1616401784845-180882ba9ba8?w=500&h=400&fit=crop',
    description: 'Serra tico-tico para cortes precisos em madeira e metal'
  },

  // Ferramentas Manuais - STANLEY
  {
    id: 5,
    name: 'Jogo de Chaves Combinadas 12 Peças',
    brand: 'Stanley',
    category: 'manuais',
    image: 'https://images.unsplash.com/photo-1426927308491-6380b6a9936f?w=500&h=400&fit=crop',
    description: 'Kit completo de chaves combinadas em aço cromo-vanádio'
  },
  {
    id: 6,
    name: 'Alicate Universal 8"',
    brand: 'Stanley',
    category: 'manuais',
    image: 'https://images.unsplash.com/photo-1586864387967-d02ef85d93e8?w=500&h=400&fit=crop',
    description: 'Alicate universal com cabo ergonômico isolado'
  },
  {
    id: 7,
    name: 'Trena Profissional 5m',
    brand: 'Stanley',
    category: 'manuais',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=500&h=400&fit=crop',
    description: 'Trena de aço com trava automática e clip para cinto'
  },
  {
    id: 8,
    name: 'Martelo de Unha 29mm',
    brand: 'Stanley',
    category: 'manuais',
    image: 'https://images.unsplash.com/photo-1586864387789-628af9feed72?w=500&h=400&fit=crop',
    description: 'Martelo profissional com cabeça em aço forjado'
  },

  // Jardinagem - STIHL
  {
    id: 9,
    name: 'Motosserra Profissional MS 250',
    brand: 'STIHL',
    category: 'jardinagem',
    image: 'https://images.unsplash.com/photo-1620030537097-3d7e4f1d0a8e?w=500&h=400&fit=crop',
    description: 'Motosserra para uso profissional em corte de árvores'
  },
  {
    id: 10,
    name: 'Roçadeira a Gasolina FS 120',
    brand: 'STIHL',
    category: 'jardinagem',
    image: 'https://images.unsplash.com/photo-1592452115680-d1a6b9b1d56a?w=500&h=400&fit=crop',
    description: 'Roçadeira potente para limpeza de terrenos'
  },
  {
    id: 11,
    name: 'Soprador de Folhas BG 56',
    brand: 'STIHL',
    category: 'jardinagem',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&h=400&fit=crop',
    description: 'Soprador portátil para limpeza de jardins'
  },
  {
    id: 12,
    name: 'Cortador de Grama RMA 235',
    brand: 'STIHL',
    category: 'jardinagem',
    image: 'https://images.unsplash.com/photo-1590212151175-e58edd96185b?w=500&h=400&fit=crop',
    description: 'Cortador de grama elétrico a bateria'
  },

  // EPIs - BRACOL/3M
  {
    id: 13,
    name: 'Óculos de Proteção Ampla Visão',
    brand: '3M',
    category: 'epis',
    image: 'https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=500&h=400&fit=crop',
    description: 'Óculos de segurança com lente antiembaçante'
  },
  {
    id: 14,
    name: 'Luvas de Proteção Mecânica',
    brand: 'Bracol',
    category: 'epis',
    image: 'https://images.unsplash.com/photo-1606206591513-89e99c8e7227?w=500&h=400&fit=crop',
    description: 'Luvas para proteção contra abrasão e cortes'
  },
  {
    id: 15,
    name: 'Capacete de Segurança Classe B',
    brand: '3M',
    category: 'epis',
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=500&h=400&fit=crop',
    description: 'Capacete com aba frontal e carneira ajustável'
  },
  {
    id: 16,
    name: 'Botina de Segurança Bico PVC',
    brand: 'Bracol',
    category: 'epis',
    image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=500&h=400&fit=crop',
    description: 'Botina com bico de proteção em PVC'
  },

  // Acessórios
  {
    id: 17,
    name: 'Jogo de Brocas para Concreto 8 Peças',
    brand: 'Makita',
    category: 'acessorios',
    image: 'https://images.unsplash.com/photo-1590479773265-7464e5d48118?w=500&h=400&fit=crop',
    description: 'Kit de brocas para concreto em diversos tamanhos'
  },
  {
    id: 18,
    name: 'Disco de Corte Diamantado 110mm',
    brand: 'Makita',
    category: 'acessorios',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&h=400&fit=crop',
    description: 'Disco diamantado para corte de cerâmica e concreto'
  },
  {
    id: 19,
    name: 'Bits para Parafusadeira 32 Peças',
    brand: 'Stanley',
    category: 'acessorios',
    image: 'https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=500&h=400&fit=crop',
    description: 'Kit completo de bits magnéticos para parafusadeira'
  },
  {
    id: 20,
    name: 'Nível a Laser Automático',
    brand: 'Stanley',
    category: 'acessorios',
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=500&h=400&fit=crop',
    description: 'Nível a laser de alta precisão para alinhamentos'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Roberto Lima',
    role: 'Construtor',
    content: 'Atendimento excelente e produtos de qualidade. A Casa das Ferramentas sempre tem o que preciso para minhas obras.',
    rating: 5
  },
  {
    id: 2,
    name: 'Maria Santos',
    role: 'Paisagista',
    content: 'As ferramentas STIHL que comprei aqui são incríveis. Durabilidade e desempenho superiores.',
    rating: 5
  },
  {
    id: 3,
    name: 'João Ferreira',
    role: 'Marceneiro',
    content: 'Recomendo a todos os profissionais. Preços justos e equipe muito capacitada para orientar.',
    rating: 5
  }
];

export const companyInfo = {
  name: 'Casa das Ferramentas',
  email: 'Fabrovidal@gmail.com',
  phone: '(94) 99185-8158',
  whatsapp: '5594991858158',
  address: 'Av. Weyne Cavalcante, nº 127 – Centro',
  city: 'Canaã dos Carajás – PA',
  zipCode: '68537-000',
  hours: 'Seg–Sex 08h–18h | Sáb 08h–12h',
  yearsExperience: new Date().getFullYear() - 2015,
  foundedYear: 2015,
  description: 'Referência em máquinas e ferramentas profissionais em Canaã dos Carajás. Distribuidor autorizado das maiores marcas mundiais.',
  about: 'A Casa das Ferramentas é referência em máquinas e ferramentas profissionais em Canaã dos Carajás. Distribuidor autorizado das maiores marcas mundiais como STIHL, Makita, Stanley e muitas outras. Oferecemos produtos originais com garantia de fábrica e atendimento especializado para profissionais e empresas da região.'
};
